import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "@/components/site/primitives";
import { Stagger, Item } from "@/components/site/motion";
import { PageHero, Section } from "@/components/site/pageparts";
import { SOLUTIONS } from "@/data/site";

export default function Solutions() {
  return (
    <div data-testid="solutions-page">
      <Seo title="Solutions" description="Sovereign memory, tuned to your sector — healthcare, finance, legal, government, education and more." />
      <PageHero
        eyebrow="Solutions"
        title="One substrate, tuned to the questions your sector actually asks."
        lead="Every sector has the same memory problem in a different shape. Here is what sovereign, verifiable, local-first memory changes for yours."
      />
      <Section>
        <Stagger className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {SOLUTIONS.map((s) => (
            <Item key={s.slug}>
              <Link
                to={`/solutions/${s.slug}`}
                data-testid={`solution-card-${s.slug}`}
                className="group flex h-full flex-col bg-ink p-8 transition-colors duration-300 hover:bg-white/[0.03]"
              >
                <div className="flex items-center justify-between">
                  <h2 className="font-serif text-2xl tracking-tight text-bone group-hover:text-saffron">{s.name}</h2>
                  <ArrowUpRight className="h-5 w-5 text-mist transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-bone" />
                </div>
                <p className="mt-4 text-[15px] leading-relaxed text-mist">{s.tagline}</p>
              </Link>
            </Item>
          ))}
        </Stagger>
      </Section>
    </div>
  );
}
